import { useEffect, useState } from "react";

const DEFAULT_RECT = {
	x: 0,
	y: 0,
	width: 0,
	height: 0,
	top: 0,
	right: 0,
	bottom: 0,
	left: 0,
};

export const useResizeObserver = ({ ref = null, selector = null } = {}) => {
	const [size, setSize] = useState(DEFAULT_RECT);

	useEffect(() => {
		const element = ref?.current || (selector ? document.querySelector(selector) : null);

		if (!element) {
			return;
		}

		const update = () => {
			const rect = element.getBoundingClientRect();
			setSize(rect);
		};

		update();

		const observer = new ResizeObserver(update);
		observer.observe(element);

		// eslint-disable-next-line consistent-return
		return () => observer.disconnect();
	}, [ref?.current, selector]);

	return size;
};
